import { render } from "./PaymentNavigation.vue?vue&type=template&id=5a81fac9"
import script from "./PaymentNavigation.vue?vue&type=script&lang=js"
export * from "./PaymentNavigation.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__